import {CreateProps} from "react-admin";
import {JournalEntryForm} from "./JournalEntryForm";
import {CustomCreate} from "../../components/CustomCreate";

export const JournalEntryCreate = (props: CreateProps) => {
  return (
    <CustomCreate {...props}>
      <JournalEntryForm />
    </CustomCreate>
  );
};
